import "./wizard.less";

import {t} from "@lingui/core/macro";
import * as React from "react";

import {IntegerField} from "@khanacademy/event-schemas";
import {useOnMountEffect} from "@khanacademy/wonder-blocks-core";
import {usePublishAnalyticsEvent} from "@khan/analytics-learning-time";

type Props = {
    age: number;
};

export default function UnderAgeGate(props: Props): React.ReactElement {
    const publishAnalyticsEvent = usePublishAnalyticsEvent();
    useOnMountEffect(() => {
        publishAnalyticsEvent({
            eventType: "KhanLabsUnderAgePageViewed",
            eventSchemaVersion: 2,
            ageAtViewing: new IntegerField(props.age),
        });
    });

    return (
        <div className="wizard-view">
            <div className="container">
                <h1 className="sad-path-heading">
                    {t`If you want to use Khanmigo, your parent or guardian needs to sign up.`}
                </h1>
                <p>
                    {t`At this time, only people ages 18 and older are eligible to sign up. Please ask your parent or guardian to sign up and add you to their account.`}
                </p>
            </div>
        </div>
    );
}
